<div class="users-management-content">
    <!-- Header -->
    <div class="header">
      <div class="title">User settings</div>
      <div class="description">Manage your account here</div>
    </div>
    <!-- Account -->
    @if (account) {
      <div class="account">

        <!-- Photo -->
        <div class="line center">
          <div class="photo">
            @if (account.photoUrl?.length) {
              <img class="image" [src]="account.photoUrl">
            }
          </div>
          <div class="upload-button">
            <label class="button secondary" for="importFile">Upload photo</label>
            <input type="file" id="importFile" (change)="uploadImage($event)" hidden>
            <div class="button secondary delete" (click)="deletePhoto()">Delete photo</div>
          </div>
        </div>

        <!-- Name -->
        <div class="row">
          <div class="title">Profile Name</div>
          <input class="input" [(ngModel)]="account.name" (blur)="updateAccount()">
        </div>

        <!-- Email -->
        <div class="row">
          <div class="title">Email</div>
          <input class="input" [(ngModel)]="account.email" (blur)="updateAccount()">
        </div>

      </div>
    }
    @if (account?.email === 'admin@cinedeck.com') {
      <div class="admin">
        <!-- Upload new Cinedeck version -->
        <div class="row">
          <div class="title">Cinedeck Server</div>
          <div class="line">
            <input type="file" (change)="selectCinedeckServerMsi($event)" />
            <div class="button" [class.disabled]="!selectedFile" [class.success]="uploaded" (click)="updateCinedeckServer()">{{ uploaded ? 'Uploaded' : ( uploading ? 'Uploading...' : 'Upload') }}</div>
          </div>
        </div>
        <!-- Open BullMQ -->
        <div class="row">
          <div class="title">BullMQ Dashboard</div>
          <div class="line">
            <div class="button" (click)="openBullMQ()">Open</div>
          </div>
        </div>
      </div>
    }
  </div>